const root = `td-punish/statistics/`
const urls = {
  caseSourceTypeStatistics: root + 'caseSourceTypeStatistics',
  queryCaseCause: root + 'queryCaseCause',
  punishCasesStatisticsWeb: root + 'punishCasesStatisticsWeb',

  punishCaseTypeStatistics: root + 'punishCaseTypeStatistics',
  casesTotal: root + 'casesTotal',
  punishTypeStatistics: root + 'punishTypeStatistics',

  punishDiscretionStatistics: root + 'punishDiscretionStatistics',
  punishRank: root + 'punishRank',
  historyFlowList: 'td-punish/actNodeApproval/historyFlowList',
  caseDetailSourceTypeStatistics: 'td-punish/caseDetailVisual/caseDetailSourceTypeStatistics',
  exportCaseDetailSourceTypeExecl: 'td-punish/caseDetailVisual/exportCaseDetailSourceTypeExecl',
  execl: 'td-punish/caseDetailVisual/execl',
  getSupportMeasureSum: root + 'getSupportMeasureSum',
  exportSupportMeasure: root + 'exportSupportMeasure',
  exportNoPunish: root + 'exportNoPunish'
}
/**案源种类统计 */
export const getCaseSourceTypeStatistics = obj => {
  return $http.get(urls.caseSourceTypeStatistics, obj)
}
/**立案（处罚）案件统计前端 */
export const getPunishCasesStatisticsWeb = obj => {
  return $http.get(urls.punishCasesStatisticsWeb, obj)
}
/**案件分类统计 */
export const getPunishCaseTypeStatistics = obj => {
  return $http.get(urls.punishCaseTypeStatistics, obj)
}
/**处罚业务分类统计 */
export const getPunishTypeStatistics = obj => {
  return $http.get(urls.punishTypeStatistics, obj)
}
/**处罚裁量应用统计 */
export const getPunishDiscretionStatistics = obj => {
  return $http.get(urls.punishDiscretionStatistics, obj)
}
/**案件办理排名 */
export const getPunishRank = obj => {
  return $http.get(urls.punishRank, obj)
}
/**企业关联的行政处罚案件列表 */
export const queryCaseCause = obj => {
  return $http.get(`${urls.queryCaseCause}`, obj)
}
/**处罚案件总计 */
export const casesTotal = obj => {
  return $http.get(`${urls.casesTotal}`, obj)
}

/**办理过程 */
export const historyFlowList = obj => {
  return $http.get(`${urls.historyFlowList}`, obj)
}
/**案源种类详情统计 */
export const caseDetailSourceTypeStatistics = obj => {
  return $http.get(`${urls.caseDetailSourceTypeStatistics}`, obj)
}
/**导出案源种类统计(废弃) */
export const exportCaseDetailSourceTypeExecl = obj => {
  return $http.get(`${urls.exportCaseDetailSourceTypeExecl}`, obj)
}
/**导出案源种类统计 */
export const exportCaseDetailSourceTypeStatisticsExecl = obj => {
  return $http.download(`${urls.execl}`, obj)
}
/** 统计汇总报表 */
export const getSupportMeasureSum = obj => {
  return $http.get(`${urls.getSupportMeasureSum}`, obj)
}
/**案件汇总导出 */
export const supportMeasureExport = obj => {
  return $http.download(`${urls.exportSupportMeasure}`, obj)
}
export const exportNoPunish = obj => {
  return $http.download(`${urls.exportNoPunish}`, obj)
}

export default {
  getCaseSourceTypeStatistics,
  getPunishCasesStatisticsWeb,
  getPunishCaseTypeStatistics,
  getPunishTypeStatistics,
  getPunishDiscretionStatistics,
  getPunishRank,
  casesTotal,
  queryCaseCause,
  historyFlowList,
  caseDetailSourceTypeStatistics,
  exportCaseDetailSourceTypeExecl,
  exportCaseDetailSourceTypeStatisticsExecl,
  getSupportMeasureSum,
  supportMeasureExport,
  exportNoPunish
}
